// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__3QyFB","main":"style_main__2b1sv","answer":"style_answer__2gMnW","text_container":"style_text_container__A63Ag","save":"style_save__26V4Z"};